export default __webpack_public_path__ + "static/media/notes.8c3628c5.png";